import * as MUI from "@mui/material";
import { ResultadosReconhecimentoProps } from "../types/mandado-facial.types";
import { CardPessoaReconhecida } from "./card-pessoa-reconhecida";
import { InfoConsultaBNMP } from "../../../../components/informativos/consulta-bnmp";

export const ResultadosReconhecimento: React.FC<
  ResultadosReconhecimentoProps
> = ({ resultado, mensagem, loading, fotoEnviada }) => {
  if (loading) {
    return null; // O loading é exibido no modal
  }

  return (
    <MUI.Stack spacing={3} sx={{ mt: 3 }}>
      {/* Título */}
      {(resultado || mensagem) && (
        <MUI.Typography
          variant="h6"
          sx={{ fontWeight: "bold", color: "primary.main" }}
        >
          🔍 Resultado do Reconhecimento Facial
        </MUI.Typography>
      )}

      {/* Mensagem de Erro/Info */}
      {mensagem && !resultado && (
        <MUI.Alert severity="info">{mensagem}</MUI.Alert>
      )}

      {/* Mensagem de Sucesso */}
      {resultado && (
        <>
          <MUI.Alert severity="success">
            <MUI.Typography variant="body1">✅ {resultado.msg}</MUI.Typography>
          </MUI.Alert>

          {/* Lista de Pessoas */}
          {resultado.pessoas.map((pessoa) => (
            <CardPessoaReconhecida
              key={`pessoa-${pessoa.nome}-${pessoa.dataNascimento}-${pessoa.grauConfianca}`}
              pessoa={pessoa}
              fotoEnviada={fotoEnviada}
            />
          ))}

          {/* Info sobre BNMP */}
          {resultado.pessoas.some(
            (p) => p.mandados && p.mandados.length > 0
          ) && <InfoConsultaBNMP />}
        </>
      )}
    </MUI.Stack>
  );
};
